import React from "react";
import { MuiGrid, MuiTypography, MuiPaper, MuiDivider, MuiMoreVertIcon, MuiPopover, MuiTab, MuiTabs, MuiList } from '../../../ui/MaterialUIComponents';
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { CommonDialogComponent } from "./dialog";
import { toast } from 'react-toastify';
import theme from '../../../../assests/theme'
import { getTextForRulesDisplayTab } from './RulesDisplayUtil';
import lodashUtil from 'lodash';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            <Box p={3}>{children}</Box>
        </Typography>
    );
}

class RulesMenuComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rulesTab: [
                { label: props.i18n.rules.menuNumberOfTeachersAndTAs, isSelected: false },
                { label: props.i18n.rules.menuFixedTeachersAndTAs, isSelected: false },
                { label: props.i18n.rules.menuMultiPeriodRules, isSelected: false },
                { label: props.i18n.rules.menuPreferredPeriods, isSelected: false },
                { label: props.i18n.rules.menuRequiredRooms, isSelected: false },
                { label: props.i18n.rules.menuJointClassConstraints, isSelected: false }
            ],
            value: 0,
            index: null,
            dialogClicked: false,
            dialogOpen: false
        }
    }

    handleMenuClick = (event) => {
        event.stopPropagation();
        const i18n = this.props.i18n
        let isSameSubjectsCellClicked = true;
        let keys = this.props.keys;
        if (keys.length > 0) {
            let firstCharOfFirstKey = keys[0].charAt(0)
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i]
                if (!key.startsWith(firstCharOfFirstKey)) {
                    toast(i18n.rules.differentCellsClicked)
                    isSameSubjectsCellClicked = false;
                    break;
                }
            }
        }
        if (isSameSubjectsCellClicked === true) {
            let dataTableMap = this.props.dataTableMap
            let rulesTab = this.state.rulesTab
            for (let x = 0; x < keys.length; x++) {
                let dataObj = dataTableMap.get(keys[x])
                if (dataObj.jointClass != undefined) {
                    let tempObj = { label: i18n.rules.menuUnJoinClassConstraints, isSelected: false }
                    let jointClassIndex = lodashUtil.findIndex(rulesTab, ["label", i18n.rules.menuJointClassConstraints])
                    if (jointClassIndex != -1) {
                        rulesTab[jointClassIndex] = tempObj
                        break
                    }
                }
            }



            // event.nativeEvent.stopImmediatePropagation();
            let AnchorEl = event.currentTarget;
            const open = Boolean(AnchorEl);
            const id = open ? 'simple-popover' : undefined;

            this.setState({
                AnchorEl: AnchorEl,
                open: open,
                id: id,
                clientX: event.clientX,
                clientY: event.clientY,
                rulesTab: rulesTab
            })
            // event.preventDefault();
        }

    }

    handleChange = () => {
        // setValue(newValue);
    };

    handleClose = () => {
        let AnchorEl = null;
        let open = Boolean(AnchorEl);
        let id = open ? 'simple-popover' : undefined;
        this.setState({
            AnchorEl: AnchorEl,
            open: open,
            id: id,
            dialogClicked: false
        })
    };

    dialogueOpen = (event, index) => {
        event.stopPropagation();
        const i18n = this.props.i18n
        let rulesTab = this.state.rulesTab
        if (rulesTab[index].label === i18n.rules.menuJointClassConstraints
            && this.props.totalPeriodsCreated) {
            window.alert(i18n.jointClassConstraints.applyChangesToProceed);
        } else {
            let rulesTab = this.state.rulesTab
            rulesTab[index].isSelected = true;
            this.setState({ index: index, dialogClicked: true, dialogOpen: true });
        }
    }

    handleChange = (event, newValue) => {
        this.setState({ value: newValue });
    }

    getDetailsDialogHeaderContent = () => {
        let cellData = this.props.dataTableMap.get(this.props.cellCode);
        let subject = cellData.subject || cellData.elective;
        let grade = cellData.grade;
        let group = cellData.group;
        return 'Constraints for ' + subject.name + ' for class ' + grade + (group ? group : '');
    }



    getDetailsDialogContent = () => {

        let cellData = this.props.dataTableMap.get(this.props.cellCode);
        return getTextForRulesDisplayTab(cellData, this.props);

    }

    handleCloseForDialog = () => {
        let rulesTab = this.state.rulesTab
        rulesTab[this.state.index].isSelected = false;
        this.setState({ dialogOpen: false, dialogClicked: false, });
    }

    render() {
        const { i18n } = this.props

        return (<div>
            <MuiMoreVertIcon fontSize='small' color="primary" onClick={(event) => this.handleMenuClick(event)} />
            {this.state.dialogClicked
                && this.state.rulesTab[this.state.index].isSelected
                && <CommonDialogComponent
                    {...this.state}
                    {...this.props}
                    label={this.state.rulesTab[this.state.index].label}
                    handleCloseForDialog={this.handleCloseForDialog}
                    handleClose={this.handleClose}
                />}
            <MuiPopover

                open={this.state.open}
                anchorEl={this.state.anchorEl}
                onClose={this.handleClose}
                anchorReference="anchorPosition"
                anchorPosition={{ top: this.state.clientY, left: this.state.clientX }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <MuiPaper square style={{ width: "350px" }}>
                    <AppBar position="static">
                        <MuiTabs
                            style={{ backgroundColor: theme.palette.grey.lighter }}
                            value={this.state.value}
                            indicatorColor={theme.indicatiorColor}
                            variant="fullWidth"
                            onChange={this.handleChange}
                        >
                            <MuiTab style={{ color: theme.textColor }} label={i18n.rules.menuRulesTab} />
                            <MuiTab style={{ color: theme.textColor }} label={i18n.rules.menuDetailsTab} />
                        </MuiTabs>
                    </AppBar>
                    <TabPanel value={this.state.value} style={{ backgroundColor: theme.palette.grey.lighter }} index={0}>

                        {this.state.rulesTab.map((rulesTitle, index) => {
                            return (
                                <React.Fragment>
                                    <MuiGrid container
                                        alignItems="center"
                                        style={{ cursor: "pointer", }}
                                        onClick={(event) => { this.dialogueOpen(event, index) }}
                                    >
                                        <MuiGrid item xs>
                                            <MuiTypography style={{ fontSize: '12px' }}>
                                                {rulesTitle.label}
                                            </MuiTypography>
                                        </MuiGrid>
                                        <MuiGrid item xs={1} container alignItems="center" justify="center">
                                            <ArrowRightIcon style={{ color: theme.palette.grey.darker }} />
                                        </MuiGrid>
                                    </MuiGrid>
                                    <MuiDivider />
                                </React.Fragment>
                            )
                        })}
                    </TabPanel>

                    <TabPanel value={this.state.value} style={{ backgroundColor: theme.palette.grey.lighter }} index={1}>


                        <MuiGrid container
                            alignItems="left"
                            direction="column"
                        >
                            <MuiGrid item xs>
                                <MuiTypography style={{ fontSize: '12px' }}>
                                    {this.getDetailsDialogHeaderContent()}
                                </MuiTypography>
                            </MuiGrid>
                            <MuiGrid item xs>

                                <MuiList style={{ height: '200', paddingTop: '0', paddingBottom: '0' }}>
                                    {this.getDetailsDialogContent()}
                                </MuiList>
                            </MuiGrid>
                        </MuiGrid>
                        <MuiDivider />


                    </TabPanel>
                </MuiPaper>
            </MuiPopover>
        </div >)
    }

}

export default RulesMenuComponent;